<template>
	<div class="income_wrap clearfix" style="margin-top: 20px;">
		<div class="card">
			<div class="card-header" style="background: none; font-size: 20px; font-weight: bold;">收入明细</div>
			<div class="card-body">
				<el-tabs v-model="activeName" @tab-click="handleClick">
				    <el-tab-pane label="全部订单" name="all">
						<el-table
						    :data="tableData"
						    border
						    style="width: 100%">
							
						    <el-table-column
						      prop="date"
						      label="商品名称/类型">
						    </el-table-column>
							
						    <el-table-column
						      prop="name"
						      label="订单编号">
						    </el-table-column>
							
						    <el-table-column
						      prop="address"
						      label="购买用户">
						    </el-table-column>
							
							<el-table-column
							  prop="address"
							  label="应付价格">
							</el-table-column>
							
							<el-table-column
							  prop="address"
							  label="交易类型">
							</el-table-column>
							
							<el-table-column
							  prop="address"
							  label="实付价格">
							</el-table-column>
							
							<el-table-column
							  prop="address"
							  label="分成比例">
							</el-table-column>
							
							<el-table-column
							  prop="address"
							  label="赏金">
							</el-table-column>
							
						  </el-table>
					</el-tab-pane>
				    <el-tab-pane label="待支付" name="no">待支付</el-tab-pane>
				    <el-tab-pane label="已完成" name="off">已完成</el-tab-pane>
				  </el-tabs>
			</div>
			
				<!-- 分页 -->
				<div class="workbench_paging clearfix" style="padding-right: 1.25rem;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[100, 200, 300, 400]"
					 :page-size="100" :total="400" layout="total, sizes, prev, pager, next, jumper">
					</el-pagination>
				</div>
				<!-- 分页 -->
				
			</div>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: 'all',
		tableData: [{
		          date: '2016-05-03',
		          name: '王小虎',
		          address: '上海市普陀区金沙江路 1518 弄'
		        }, {
		          date: '2016-05-02',
		          name: '王小虎',
		          address: '上海市普陀区金沙江路 1518 弄'
		        }, {
		          date: '2016-05-04',
		          name: '王小虎',
		          address: '上海市普陀区金沙江路 1518 弄'
		        }, {
		          date: '2016-05-01',
		          name: '王小虎',
		          address: '上海市普陀区金沙江路 1518 弄'
		        }, {
		          date: '2016-05-08',
		          name: '王小虎',
		          address: '上海市普陀区金沙江路 1518 弄'
		        }, {
		          date: '2016-05-06',
		          name: '王小虎',
		          address: '上海市普陀区金沙江路 1518 弄'
		        }, {
		          date: '2016-05-07',
		          name: '王小虎',
		          address: '上海市普陀区金沙江路 1518 弄'
		        }]
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
	  handleSizeChange(val) {
	  	console.log(`每页 ${val} 条`);
	  },
	  handleCurrentChange(val) {
	  	console.log(`当前页: ${val}`);
	  },
    }
  };
</script>

<style lang="less">
	.income_wrap {
		.card-body { padding: 0 0 1.25rem;}
		.el-tabs__header {
			margin: 0 0 30px;
		}
		.el-tabs__nav-scroll {
			padding: 0 1.25rem;
			.el-tabs__item {
				height: 50px; line-height: 50px; padding: 0 30px;
			}
		}
		.el-tab-pane {
			padding: 0 1.25rem;
		}
	}
</style>
